export function HeadsetIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M10 3.33341C6.3181 3.33341 3.33334 6.31818 3.33334 10.0001H5.83334C6.75381 10.0001 7.5 10.7462 7.5 11.6667V15.8334C7.5 16.7539 6.75381 17.5001 5.83334 17.5001H3.33334C2.41286 17.5001 1.66667 16.7539 1.66667 15.8334V10.0001C1.66667 5.39771 5.39763 1.66675 10 1.66675C14.6023 1.66675 18.3333 5.39771 18.3333 10.0001V15.8334C18.3333 16.7539 17.5872 17.5001 16.6667 17.5001H14.1667C13.2462 17.5001 12.5 16.7539 12.5 15.8334V11.6667C12.5 10.7462 13.2462 10.0001 14.1667 10.0001H16.6667C16.6667 6.31818 13.6819 3.33341 10 3.33341ZM3.33334 11.6667V15.8334H5.83334V11.6667H3.33334ZM14.1667 11.6667V15.8334H16.6667V11.6667H14.1667Z" fill="currentColor" />
    </svg>
  );
}

HeadsetIcon.displayName = 'HeadsetIcon';